<template>
  <div class="section-box" style="min-height: 800px;">
    <h3 style="margin:0 0 16px;color: #1f2f3d;font-weight: 400;font-size: 16px;">{{patternType=='a'?"选题组卷":"随机组卷"}}</h3>
    <el-tabs v-model="activeName" type="card">
      <el-tab-pane label="创建试卷" name="create" :disabled="activeName == 'create'?false:true">
        <el-form :inline="true" ref="ruleForm" label-width="130px" label-position="left" :rules="rules" :model="form" class="one-ruleForm" >
          <el-form-item label="考试来源：" prop="npaperSource">
            <el-select size="medium" v-model="form.npaperSource" placeholder="请选择考试来源" clearable style="width:550px;margin-right: 80px;">
              <el-option :value="1" label="速派平台"></el-option>
              <el-option :value="2" label="合作平台"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="费用类型：" prop="ncostType">
            <el-select size="medium" v-model="form.ncostType" placeholder="请选择费用类型" clearable style="width:550px;margin-right: 80px;">
              <el-option :value="1" label="免费"></el-option>
              <el-option :value="2" label="低价位"></el-option>
              <el-option :value="3" label="中价位"></el-option>
              <el-option :value="4" label="高价位"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="渠道SKU：">
            <el-input size="medium" v-model="form.schannelSku" placeholder="请输入渠道SKU"  style="width:550px;margin-right: 80px;"></el-input>
          </el-form-item>
          <el-form-item label="考试标准价：">
            <el-input size="medium" v-model="form.ntestPrice" placeholder="请输入考试标准价"  style="width:550px;margin-right: 80px;"></el-input>
          </el-form-item>
          <el-form-item label="渠道商品指导价：">
            <el-input size="medium" v-model="form.nchannelPrice" placeholder="请输入渠道商品指导价"  style="width:550px;margin-right: 80px;"></el-input>
          </el-form-item>
          <el-form-item label="考试名称：" prop="spaperName">
            <el-input size="medium" v-model="form.spaperName" placeholder="请输入考试名称"  style="width:550px;margin-right: 80px;"></el-input>
          </el-form-item>
          <el-form-item label="考试类别：" prop="npaperCategory">
            <el-select size="medium" v-model="form.npaperCategory" placeholder="请选择考试类别" clearable style="width:550px;margin-right: 80px;" @change="sfieldIsMandatory">
              <el-option :value="item.value" :label="item.label" v-for="(item, index) in QUESTIONS_TYPE.CATEGORY" :key="index"></el-option>
            </el-select>
          </el-form-item>
          <template v-if="isMandatory">
            <el-form-item label="服务内容：">
              <el-select 
                size="medium" 
                :disabled="isDisabledServiceSelect"
                v-model="form.serviceStageId" 
                placeholder="请选择服务内容" 
                clearable 
                style="width:550px;margin-right: 80px;"
              >
                <el-option :value="item.key" :label="item.value" v-for="(item, index) in serviceList" :key="index" :style="{'max-width': '550px'}"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="考试领域：" prop="sfieldIds">
              <el-select 
                size="medium" 
                v-model="form.sfieldIds" 
                placeholder="请选择考试领域" 
                clearable
                multiple 
                collapse-tags 
                filterable 
                style="width:550px;margin-right: 80px;" 
                @clear="clearProductList" 
                @change="getProductList"
              >
                <el-option :value="item.key" :label="item.value" v-for="(item, index) in domianList" :key="index"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="产品内容：">
              <el-select 
                size="medium" 
                v-model="form.sproductIds" 
                :disabled="isDisabledProduct" 
                placeholder="请选择考试产品" 
                clearable
                multiple 
                collapse-tags 
                filterable 
                style="width:550px;margin-right: 80px;" 
                @clear="clearBrandId" 
                @change="disabledSbrandId"
              >
                <el-option :value="item.key" :label="item.value" v-for="(item, index) in productList" :key="index"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="考试品牌：">
              <el-select 
                size="medium" 
                v-model="form.sbrandId" 
                :disabled="isDisabledBrandId"  
                placeholder="请选择考试品牌" 
                clearable 
                filterable 
                style="width:550px;margin-right: 80px;"
              >
                <el-option :value="item.key" :label="item.value" v-for="(item, index) in brandList" :key="index"></el-option>
              </el-select>
            </el-form-item>
          </template>
          <el-form-item label="难度类别：" prop="ndifficultyLevel">
            <el-select size="medium" v-model="form.ndifficultyLevel" placeholder="请选择试题难度" clearable style="width:550px;margin-right: 80px;">
              <el-option :value="item.value" :label="item.label" v-for="(item, index) in TEST_TYPE.DIFFICULTY" :key="index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="属性类型：" prop="nattributeType">
            <el-select size="medium" v-model="form.nattributeType" placeholder="请选择属性类型" clearable style="width:550px;margin-right: 80px;">
              <el-option :value="1" label="标准课程"></el-option>
              <el-option :value="2" label="定制化课程"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="认证情况：" prop="nauthentication">
            <el-select size="medium" v-model="form.nauthentication" placeholder="请选择认证情况" clearable style="width:550px;margin-right: 80px;">
              <el-option :value="item.value" :label="item.label" v-for="(item, index) in QUESTIONS_TYPE.CATION" :key="index"></el-option>
              <!-- <el-option :value="3" label="原厂认证"></el-option> -->
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="关联课程：">
            <el-select size="medium" v-model="form.scurriculumId" placeholder="请选择关联课程" clearable filterable style="width:550px;margin-right: 80px;">
              <el-option :value="item.key" :label="item.value" v-for="(item, index) in courseList" :key="index" :style="{'max-width': '550px'}"></el-option>
            </el-select>
          </el-form-item> -->
          <div class="next-button">
            <el-button type="danger" size="small" @click="submitNextStepForm('ruleForm')">下一步</el-button>
          </div>
        </el-form>
      </el-tab-pane>
      <template v-if="patternType=='a'">
        <el-tab-pane label="添加试题" name="add" v-loading="setLoading" :disabled="activeName == 'add'?false:true">
          <div class="one-ruleForm"> 
            <el-row :gutter="40">
              <el-col :span="6" style="min-width: 460px;margin-top: 50px;">
                <div class="test-total">
                  <div class="test-itme-total">
                    <div class="itme-head">
                      <h4 @click="onCollapseItem(1)">单选题</h4>
                      <div>
                        <template>
                          <el-popconfirm
                            icon="el-icon-info"
                            iconColor="red"
                            title="确定要删除所有单选题吗？"
                            @confirm="deleteAllQuestions(1)"
                          >
                            <el-button v-show="singleList.length" type="text" slot="reference" size="mini" class="danger">全部清除</el-button>
                          </el-popconfirm>
                        </template>
                        <el-button type="text" size="mini" class="add-test-button" @click="addQuestionsDrawer">添加试题</el-button>
                      </div>
                    </div>
                    <div class="item-content">
                      <div class="text">共<span>{{singleList.length}}</span>题，共<span>{{singleCommonNum}}</span>分</div>
                      <div v-show="singleList.length">
                        <el-form label-width="100px" class="demo-ruleForm">
                          <el-form-item label="每题分数">
                            <el-input size="medium" type="text" v-model.number="singleScore" style="width: 100px;" placeholder="输入分数"></el-input>
                          </el-form-item>
                        </el-form>
                      </div>
                    </div>
                  </div>
                  <div class="test-itme-total">
                    <div class="itme-head">
                      <h4 @click="onCollapseItem(2)">多选题</h4>
                      <div>
                        <template>
                          <el-popconfirm
                            icon="el-icon-info"
                            iconColor="red"
                            title="确定要删除所有多选题吗？"
                            @confirm="deleteAllQuestions(2)"
                          >
                            <el-button v-show="multiList.length" type="text" slot="reference" size="mini" class="danger">全部清除</el-button>
                          </el-popconfirm>
                        </template>
                        <el-button type="text" size="mini" class="add-test-button" @click="addQuestionsDrawer">添加试题</el-button>
                      </div>
                    </div>
                    <div class="item-content">
                      <div class="text">共<span>{{multiList.length}}</span>题，共<span>{{multiCommonNum}}</span>分</div>
                      <div v-show="multiList.length">
                        <el-form label-width="100px" class="demo-ruleForm">
                          <el-form-item label="每题分数">
                            <el-input size="medium" type="text" v-model.number="multiScore" style="width: 100px;" placeholder="输入分数"></el-input>
                          </el-form-item>
                        </el-form>
                      </div>
                    </div>
                  </div>
                  <div class="test-itme-total">
                    <div class="itme-head">
                      <h4 @click="onCollapseItem(3)">判断题</h4>
                      <div>
                        <template >
                          <el-popconfirm
                            icon="el-icon-info"
                            iconColor="red"
                            title="确定要删除所有判断题吗？"
                            @confirm="deleteAllQuestions(3)"
                          >
                            <el-button v-show="judgeList.length" type="text" slot="reference" size="mini" class="danger">全部清除</el-button>
                          </el-popconfirm>
                        </template>
                        <el-button type="text" size="mini" class="add-test-button" @click="addQuestionsDrawer">添加试题</el-button>
                      </div>
                    </div>
                    <div class="item-content">
                      <div class="text">共<span>{{judgeList.length}}</span>题，共<span>{{judgeCommonNum}}</span>分</div>
                      <div v-show="judgeList.length">
                        <el-form label-width="100px" class="demo-ruleForm">
                          <el-form-item label="每题分数">
                            <el-input size="medium" type="text" v-model.number="judgeScroe" style="width: 100px;" placeholder="输入分数"></el-input>
                          </el-form-item>
                        </el-form>
                      </div>
                    </div>
                  </div>
                  <div class="test-bottom-total">
                    <div>题数：<span>{{totalTopicNum}}</span> 题</div>
                    <div>总分：<span>{{totalScoreNum}}</span> 分</div>
                  </div>
                </div>
              </el-col>
              <el-col :span="14" style="min-width: 800px">
                <h3 class="test-title">{{form.spaperName}}</h3>
                <div class="test-content">
                  <el-collapse  v-model="activeNames">
                    <el-collapse-item name="a">
                      <template slot="title">
                        <h4>单选题</h4>
                      </template>
                      <template v-if="singleList.length">
                        <div class="test-list" v-for="(item, index) in singleList" :key="index">
                          <div class="test-single">
                            <h5 class="test-min-title">{{index+1}}.{{item.squestions}}</h5>
                            <div class="test-list-content">
                              <div class="test-select">
                                <template v-for="(items, indexs) in item.sopArr">
                                  <div class="test-select-itme" :class="item.srightAnswer.indexOf(String.fromCharCode(indexs+65)) != -1?'correct':''" :key="indexs">{{String.fromCharCode(indexs+65)}}、{{items.label}}</div>
                                </template>
                              </div>
                              <div class="test-answer-oper">
                                <div class="correct">答案：{{item.srightAnswer}}</div>
                                <div>
                                  <el-button type="text" @click="handleOpen(item)">编辑</el-button>
                                  <template>
                                    <el-popconfirm
                                      icon="el-icon-info"
                                      iconColor="red"
                                      title="确定删除此单选题吗？"
                                      @confirm="deleteRow(index, singleList)"
                                    >
                                      <el-button type="text" slot="reference" class="danger" style="margin-left:10px;margin-right:10px;">删除</el-button>
                                    </el-popconfirm>
                                  </template>
                                  <el-button type="text" class="empty" @click="upClick(index,singleList)" v-if="index !== 0">上移</el-button>
                                  <el-button type="text" class="empty" @click="downClick(index,singleList)" v-if="index !== singleList.length - 1">下移</el-button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </template>
                      <template v-else>
                        <div style="text-align: center;line-height: 100px;">暂无试题，请点击添加试题</div>
                      </template>
                    </el-collapse-item>
                    <el-collapse-item name="b">
                      <template slot="title">
                        <h4>多选题</h4>
                      </template>
                      <template v-if="multiList.length">
                        <div class="test-list" v-for="(item, index) in multiList" :key="index">
                          <div class="test-more">
                            <h5 class="test-min-title">{{index+1}}.{{item.squestions}}</h5>
                            <div class="test-list-content">
                              <div class="test-select">
                                <template v-for="(items, indexs) in item.sopArr">
                                  <div class="test-select-itme" :class="item.srightAnswer.indexOf(String.fromCharCode(indexs+65)) != -1?'correct':''" :key="indexs">{{String.fromCharCode(indexs+65)}}、{{items.label}}</div>
                                </template>
                              </div>
                              <div class="test-answer-oper">
                                <div class="correct">答案：{{item.srightAnswer}}</div>
                                <div>
                                  <el-button type="text" @click="handleOpen(item)">编辑</el-button>
                                  <template>
                                    <el-popconfirm
                                      icon="el-icon-info"
                                      iconColor="red"
                                      title="确定删除此多选题吗？"
                                      @confirm="deleteRow(index, multiList)"
                                    >
                                      <el-button type="text" slot="reference" class="danger" style="margin-left:10px;margin-right:10px;">删除</el-button>
                                    </el-popconfirm>
                                  </template>
                                  <el-button type="text" class="empty" @click="upClick(index,multiList)" v-if="index !== 0">上移</el-button>
                                  <el-button type="text" class="empty" @click="downClick(index,multiList)" v-if="index !== multiList.length - 1">下移</el-button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </template>
                      <template v-else>
                        <div style="text-align: center;line-height: 100px;">暂无试题，请点击添加试题</div>
                      </template>
                    </el-collapse-item>
                    <el-collapse-item name="c">
                      <template slot="title">
                        <h4>判断题</h4>
                      </template>
                      <template v-if="judgeList.length">
                        <div class="test-list" v-for="(item, index) in judgeList" :key="index">
                          <div class="test-is">
                            <h5 class="test-min-title">{{index+1}}.{{item.squestions}}</h5>
                            <div class="test-list-content">
                              <div class="test-select">
                                <template v-for="(items, indexs) in item.sopArr">
                                  <div class="test-select-itme" :class="item.srightAnswer.indexOf(String.fromCharCode(indexs+65)) != -1||item.srightAnswer=='正确'&&items.label=='正确'||item.srightAnswer=='错误'&&items.label=='错误'?'correct':''" :key="indexs">{{String.fromCharCode(indexs+65)}}、{{items.label}}</div>
                                </template>
                              </div>
                              <div class="test-answer-oper">
                                <div class="correct">答案：{{item.srightAnswer}}</div>
                                <div>
                                  <el-button type="text" @click="handleOpen(item)">编辑</el-button>
                                  <template>
                                    <el-popconfirm
                                      icon="el-icon-info"
                                      iconColor="red"
                                      title="确定删除此判断题吗？"
                                      @confirm="deleteRow(index, judgeList)"
                                    >
                                      <el-button type="text" slot="reference" class="danger" style="margin-left:10px;margin-right:10px;">删除</el-button>
                                    </el-popconfirm>
                                  </template>
                                  <el-button type="text" class="empty" @click="upClick(index,judgeList)" v-if="index !== 0">上移</el-button>
                                  <el-button type="text" class="empty" @click="downClick(index,judgeList)" v-if="index !== judgeList.length - 1">下移</el-button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </template>
                      <template v-else>
                        <div style="text-align: center;line-height: 100px;">暂无试题，请点击添加试题</div>
                      </template>
                    </el-collapse-item>
                  </el-collapse>
                </div>
              </el-col>
            </el-row>
            <div class="next-button">
              <el-button type="danger" size="small"  @click="submitNextStep()">下一步</el-button>
            </div>
          </div>
        </el-tab-pane>
      </template>
      <template v-else>
        <el-tab-pane label="添加试题" name="addtwo" v-loading="setLoading" :disabled="activeName=='addtwo'?false:true">
          <div class="one-ruleForm">
            <el-row>
              <el-col :span="14" style="min-width: 800px">
                <h3 class="test-title">{{form.spaperName}}</h3>
                <div class="test-content">
                  <div class="test-two-add">
                    <div class="test-two-item-head">
                      <h4>单选题</h4>
                      <!-- <div class="two-head-totel">总分：<span>30</span></div> -->
                    </div>
                    <template v-if="randomSingleData.length">
                      <div class="test-two-content">
                        <div class="test-two-items" v-for="(item,index) in randomSingleData" :key="index">
                          <div class="two-items-list">
                            <div>总分：{{item.typeScore}}</div>
                            <div>难度：
                              <template v-if="item.nquestionLevel == 1">入门</template>
                              <template v-else-if="item.nquestionLevel == 2">中等</template>
                              <template v-else-if="item.nquestionLevel == 3">困难</template>
                              <template v-else>无</template>
                            </div>
                            <div>题数：{{item.num}}</div>
                            <div>每题分数：{{item.score}}</div>
                            <div>试题分类：
                              <template v-if="item.nquestionCategory==2">服务安全规范</template>
                              <template v-else-if="item.nquestionCategory==3">服务能力</template>
                              <template v-else>--</template>
                            </div>
                            <template v-if="item.nquestionCategory==3">
                              <div>领域：{{item.sfield || '--'}}</div>
                              <div>产品：{{item.sproduct || '--'}}</div>
                              <div>品牌：{{item.sbrand || '--'}}</div>
                            </template>
                          </div>
                          <div class="two-items-button">
                            <el-button type="text" class="empty" @click="randomEditData(randomSingleData[index],1,index)">编辑</el-button>
                            <template>
                              <el-popconfirm
                                icon="el-icon-info"
                                iconColor="red"
                                title="确定删除此随机题组吗？"
                                @confirm="deleteRandom(1,index)"
                              >
                                <el-button type="text" slot="reference" class="danger" style="margin-left:10px;margin-right:10px;">删除</el-button>
                              </el-popconfirm>
                            </template>
                          </div>
                        </div>
                      </div>
                    </template>
                    <div class="test-add-button">
                      <el-button type="danger" @click="handleOpenTwo(1)">添加试题</el-button>
                    </div>
                  </div>
                  <div class="test-two-add">
                    <div class="test-two-item-head">
                      <h4>多选题</h4>
                    </div>
                    <template v-if="randomMultiData.length">
                      <div class="test-two-content">
                        <div class="test-two-items" v-for="(item,index) in randomMultiData" :key="index">
                          <div class="two-items-list">
                            <div>总分：{{item.typeScore}}</div>
                            <div>难度：
                              <template v-if="item.nquestionLevel == 1">入门</template>
                              <template v-else-if="item.nquestionLevel == 2">中等</template>
                              <template v-else-if="item.nquestionLevel == 3">困难</template>
                              <template v-else>无</template>
                            </div>
                            <div>题数：{{item.num}}</div>
                            <div>每题分数：{{item.score}}</div>
                            <div>试题分类：
                              <template v-if="item.nquestionCategory==2">服务安全规范</template>
                              <template v-else-if="item.nquestionCategory==3">服务能力</template>
                              <template v-else>--</template>
                            </div>
                            <template v-if="item.nquestionCategory==3">
                              <div>领域：{{item.sfield || '--'}}</div>
                              <div>产品：{{item.sproduct || '--'}}</div>
                              <div>品牌：{{item.sbrand || '--'}}</div>
                            </template>
                          </div>
                          <div class="two-items-button">
                            <el-button type="text" class="empty" @click="randomEditData(randomMultiData[index],2,index)">编辑</el-button>
                            <template>
                              <el-popconfirm
                                icon="el-icon-info"
                                iconColor="red"
                                title="确定删除此随机题组吗？"
                                @confirm="deleteRandom(2,index)"
                              >
                                <el-button type="text" slot="reference" class="danger" style="margin-left:10px;margin-right:10px;">删除</el-button>
                              </el-popconfirm>
                            </template>
                          </div>
                        </div>
                      </div>
                    </template>
                    <div class="test-add-button">
                      <el-button type="danger" @click="handleOpenTwo(2)">添加试题</el-button>
                    </div>
                  </div>
                  <div class="test-two-add">
                    <div class="test-two-item-head">
                      <h4>判断题</h4>
                    </div>
                    <template v-if="randomJudgeData.length">
                      <div class="test-two-content">
                        <div class="test-two-items" v-for="(item,index) in randomJudgeData" :key="index">
                          <div class="two-items-list">
                            <div>总分：{{item.typeScore}}</div>
                            <div>难度：
                              <template v-if="item.nquestionLevel == 1">入门</template>
                              <template v-else-if="item.nquestionLevel == 2">中等</template>
                              <template v-else-if="item.nquestionLevel == 3">困难</template>
                              <template v-else>无</template>
                            </div>
                            <div>题数：{{item.num}}</div>
                            <div>每题分数：{{item.score}}</div>
                            <div>试题分类：
                              <template v-if="item.nquestionCategory==2">服务安全规范</template>
                              <template v-else-if="item.nquestionCategory==3">服务能力</template>
                              <template v-else>--</template>
                            </div>
                            <template v-if="item.nquestionCategory==3">
                              <div>领域：{{item.sfield || '--'}}</div>
                              <div>产品：{{item.sproduct || '--'}}</div>
                              <div>品牌：{{item.sbrand || '--'}}</div>
                            </template>
                          </div>
                          <div class="two-items-button">
                            <el-button type="text" class="empty" @click="randomEditData(randomJudgeData[index],3, index)">编辑</el-button>
                            <template>
                              <el-popconfirm
                                icon="el-icon-info"
                                iconColor="red"
                                title="确定删除此随机题组吗？"
                                @confirm="deleteRandom(3, index)"
                              >
                                <el-button type="text" slot="reference" class="danger" style="margin-left:10px;margin-right:10px;">删除</el-button>
                              </el-popconfirm>
                            </template>
                          </div>
                        </div>
                      </div>
                    </template>
                    <div class="test-add-button">
                      <el-button type="danger" @click="handleOpenTwo(3)">添加试题</el-button>
                    </div>
                  </div>
                   <div class="footer">
                    <div>题数：<span>{{randomTotalTopicNum}}</span> 题</div>
                    <div>总数：<span>{{randomTotalScoreNum}}</span> 分</div>
                  </div>
                </div>
              </el-col>
            </el-row>
            <div class="next-button">
              <el-button type="danger" size="small"  @click="randomSubmitNextStep()">下一步</el-button>
            </div>
          </div>
        </el-tab-pane>
      </template>
      <el-tab-pane label="试卷设置" name="test" :disabled="activeName == 'test'?false:true">
        <div class="one-ruleForm">
          <div class="test-total">
            <div class="test-itme-total">
              <div class="itme-head">
                <h4>试卷信息</h4>
                <div>
                  <el-button type="text" size="mini" class="add-test-button" @click="prevEditor">编辑</el-button>
                </div>
              </div>
              <div class="item-content">
                <div>
                  <el-form :inline="true" label-width="100px" label-position="left" >
                    <el-form-item label="总分：">
                      <div style="width:550px;margin-right: 80px;">{{totalScoreNumThree}}</div>
                    </el-form-item>
                    <el-form-item label="创建人：" v-if="creatorName">
                      <div style="width:550px;margin-right: 80px;">{{creatorName}}</div>
                    </el-form-item>
                    <el-form-item label="试题数量：">
                      <div style="width:550px;margin-right: 80px;">{{totalTopicNumThree}}</div>
                    </el-form-item>
                    <el-form-item label="创建时间：" v-if="creatorTime">
                      <div style="width:550px;margin-right: 80px;">{{creatorTime}}</div>
                    </el-form-item>
                  </el-form>
                </div>
              </div>
            </div>
            <div class="test-itme-total">
              <div class="itme-head">
                <h4>试卷设置</h4>
              </div>
              <div class="item-content">
                <div class="form-test-set">
                  <el-form :inline="true" label-width="100px" label-position="left" >
                    <el-form-item label="考试时间：">
                      <div style="width:550px;margin-right: 80px;">
                        <el-date-picker
                          size="medium"
                          type="datetimerange"
                          format="yyyy-MM-dd HH:mm:ss"
                          value-format="yyyy-MM-dd HH:mm:ss"
                          range-separator="至"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期"
                          style="width: 550px;"
                          v-model="form.dpublishTime"
                          :default-time="['00:00:01', '23:59:59']"
                        ></el-date-picker>
                      </div>
                    </el-form-item>
                    <el-form-item label="答卷时长：">
                      <div style="width:550px;margin-right: 80px;">
                        <template>
                          <el-radio-group v-model="durationRadio" style="width: 190px">
                            <el-radio :label="1">不限时长</el-radio>
                            <el-radio :label="2">有限时长</el-radio>
                          </el-radio-group>
                        </template>
                        <el-input v-if="durationRadio == 2" placeholder="请输入时长"  style="width:340px;margin-left: 20px;" v-model="form.sanswerDuration"></el-input>
                      </div>
                    </el-form-item>
                    <el-form-item label="答题次数：">
                      <div style="width:550px;margin-right: 80px;">
                        <template>
                          <el-radio-group v-model="secondRadio" style="width: 190px">
                            <el-radio :label="1">无限次</el-radio>
                            <el-radio :label="2">有限次</el-radio>
                          </el-radio-group>
                        </template>
                        <el-input v-if="secondRadio == 2" placeholder="请输入次数"  style="width:340px;margin-left: 20px;" v-model="form.sanswerSecond"></el-input>
                      </div>
                    </el-form-item>
                    <el-form-item label="及格分数：">
                      <el-input placeholder="请输入及格分数"  style="width:550px;margin-right: 80px;" v-model="form.npassScore"></el-input>
                    </el-form-item>
                    <el-form-item label="优秀分数：">
                      <el-input placeholder="请输入优秀分数"  style="width:550px;margin-right: 80px;" v-model="form.nexcellentScore"></el-input>
                    </el-form-item>
                  </el-form>
                </div>
              </div>
            </div>
            <div class="test-itme-total">
              <div class="itme-head">
                <h4>考试说明</h4>
              </div>
              <div class="item-content">
                <div class="form-test-set">
                  <el-input type="textarea" style="width: 650px;" maxlength="20" :rows="6" v-model="form.spaperExplain" placeholder="请输入内容（最多20个字 非必填）"></el-input>
                </div>
              </div>
            </div>
          </div>
          <div class="next-button">
            <el-button type="primary" size="small" @click="submitAllData(0)" :loading="submitAllLoading">保 存</el-button>
            <el-button type="warning" size="small"  @click="submitAllData(1)" :loading="submitAllLoading">发 布</el-button>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
    <el-drawer
      title=""
      :visible.sync="drawer"
      custom-class="demo-drawer"
      ref="drawer"
      size="74%"
      >
      <div class="demo-drawer__content">
        <el-form inline label-width="90px">
          <el-form-item label="题型：">
            <el-select size="medium"  v-model="drawerForm.nquestionType" style="width:150px;" placeholder="请选择题型">
              <el-option :value="item.value" :label="item.label" v-for="(item, index) in TEST_TYPE.TYPES" :key="index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="试题分类：">
            <el-select size="medium" v-model="drawerForm.nquestionCategory" style="width:150px;" placeholder="请选择试题分类">
              <el-option :value="item.value" :label="item.label" v-for="(item, index) in QUESTIONS_TYPE.CLASSIFY" :key="index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="试题内容：">
            <el-input size="medium" v-model="drawerForm.squestions" style="width:150px;" placeholder="请输入试题内容" type="text" />
          </el-form-item>
          <el-form-item label="难度：">
            <el-select size="medium" v-model="drawerForm.nquestionLevel" style="width:150px;" placeholder="请选择试题难度">
              <el-option :value="item.value" :label="item.label" v-for="(item, index) in TEST_TYPE.DIFFICULTY" :key="index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="领域：">
            <el-select size="medium" v-model="drawerForm.sfieldId" filterable style="width:150px;" placeholder="请选择领域" @change="getProductListTwo">
              <el-option :value="item.key" :label="item.value" v-for="(item, index) in domianList" :key="index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="产品：">
            <el-select size="medium" v-model="drawerForm.sproductId" filterable style="width:150px;" placeholder="请选择产品">
              <el-option :value="item.key" :label="item.value" v-for="(item, index) in productListTwo" :key="index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="品牌：">
            <el-select size="medium" v-model="drawerForm.sbrandId" filterable style="width:150px;" placeholder="请选择品牌">
              <el-option :value="item.key" :label="item.value" v-for="(item, index) in brandList" :key="index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="创建人：">
            <el-input size="medium" v-model="drawerForm.createrName" style="width:150px;" placeholder="请输入创建人" type="text" />
          </el-form-item>
          <el-form-item label="创建时间：">
            <el-date-picker
              size="medium"
              v-model="drawerForm.pickerTime"
              type="daterange"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            ></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button size="medium" type="primary" @click="handleSearch">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button size="medium" type="success" @click="handleReset">重置</el-button>
          </el-form-item>
        </el-form>
          <!-- height="580" -->
        <el-table
          :stripe="true"
          v-loading="listLoading"
          :data="tableData"
          style="width: 100%;"
          @selection-change="handleSelectionChange"
          ref="multipleTable"
        >
          <el-table-column type="selection" width="55" :selectable="checkSelectable"></el-table-column>
          <el-table-column label="题型" width="120">
            <template slot-scope="scope">
              <span v-if="scope.row.nquestionType == 1">单选</span>
              <span v-else-if="scope.row.nquestionType == 2">多选</span>
              <span v-else-if="scope.row.nquestionType == 3">判断</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column label="试题分类" width="140">
            <template slot-scope="scope">
              <span v-if="scope.row.nquestionCategory == 1">课程考试</span>
              <span v-else-if="scope.row.nquestionCategory == 2">服务安全规范</span>
              <span v-else-if="scope.row.nquestionCategory == 3">服务能力</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column prop="squestions" label="试题内容" show-overflow-tooltip width="260"></el-table-column>
          <el-table-column label="试题难度" width="120">
            <template slot-scope="scope">
              <span v-if="scope.row.nquestionLevel === 0">无</span>
              <span v-else-if="scope.row.nquestionLevel == 1">入门</span>
              <span v-else-if="scope.row.nquestionLevel == 2">中等</span>
              <span v-else-if="scope.row.nquestionLevel == 3">困难</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column label="领域" show-overflow-tooltip width="120">
            <template slot-scope="scope">
              <span>{{ scope.row.sfield||'--' }}</span>
            </template>
          </el-table-column>
          <el-table-column label="产品" show-overflow-tooltip width="120">
            <template slot-scope="scope">
              <span>{{ scope.row.sproduct||'--' }}</span>
            </template>
          </el-table-column>
          <el-table-column label="品牌" show-overflow-tooltip width="120">
            <template slot-scope="scope">
              <span>{{ scope.row.sbrand||'--' }}</span>
            </template>
          </el-table-column>
          <el-table-column label="创始人" show-overflow-tooltip width="120">
            <template slot-scope="scope">
              <span>{{ scope.row.createrName||'--' }}</span>
            </template>
          </el-table-column>
          <el-table-column label="创建时间">
            <template slot-scope="scope">
              <span>{{ scope.row.daddDate||'--' }}</span>
            </template>
          </el-table-column>
        </el-table>
        <div style="margin: 10px;overflow: hidden">
            <div style="float: right;" v-show="tableData.length">
                <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="drawerForm.pageNum"
                :page-sizes="[10, 20, 50, 100, 200]"
                :page-size="drawerForm.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total">
                </el-pagination>
            </div>
        </div>
        <div class="demo-drawer__footer">
          <el-button @click="handleClose()">取 消</el-button>
          <el-button type="primary" @click="confirmQuestionsSubmit">确 定</el-button>
        </div>
      </div>
    </el-drawer>
    <div v-if="loadModal">
      <CusModal ref="modal" @onSubmit="onEditSubmit"/>
    </div>
    <div v-if="loadModal2">
      <CusModalTwo ref="modalTwo" @seveRandomNextBtn="seveRandomNextBtn"/>
    </div>
  </div>
</template>

<script>
import { TEST_TYPE, QUESTIONS_TYPE } from '@/config/const/common.js'
import { getProductSelect, getServiceSelect} from '@/service/area'
import { mapState, mapActions } from "vuex";
import {
    questionBankList,           //获取列表
    questionBankModel,          //试题 新增/修改
    examinationSet,             //提交/编辑
    questionBankRandom,         //提交添加 随机组题
    // questionBankCountByFpbId,   //对应领域|产品|品牌下的对应题目数量查询
    examinationSetEcho,         //回显
    questionBankIsExist,        //点击批量更新/批量删除/编辑/删除调用
    questionBankQueryNum,       //随机组卷点击添加试题调用
} from "@/service/examination";
import { getStorageUserRoleId } from '@/utils/store'
import CusModal from './index/modal'

import CusModalTwo from './index/modalTwo'
  export default {
    components: {
      CusModal,
      CusModalTwo
    },
    data() {
      return {
        TEST_TYPE,
        QUESTIONS_TYPE,
        productList: [],            //获取产品列表
        serviceList: [],             //获取服务类型（服务内容）
        drawer: false,              //添加试题弹框
        listLoading: false,         //渲染列表loading

        activeName: 'create',

        loadModal: false,
        loadModal2: false,

        isDisabledProduct:true,
        isDisabledBrandId: true,
        isDisabledServiceSelect: true,    //禁止服务内容

        submitAllLoading: false,    //点击保存/发布loading

        form: {
          spaperNo: '',           //新增不用 修改用

          

          npaperAttribute: 2,     //1=认证考试，2=课程考试
          norganizedPattern: '',  //1=选题组卷，2=随机组卷
          // 第一步
          npaperSource: '',       //1=速派平台，2=合作平台（考试来源）
          ncostType: '',          //1=免费，2=低价位，3=中价位，4=高价位（费用类型）
          schannelSku: '',        //渠道SKU
          ntestPrice: '',         //考试标准价
          nchannelPrice: '',      //渠道商品指导价
          ndifficultyLevel: '',   //0=无，1=入门，2=中等，3=困难（难度类别）
          nattributeType: '',     //属性类型
          scurriculumId: '',      //关联课程id
          serviceStageId: '',     // 服务内容

          //第二步 (随机组卷)
          examStypeSetRs: [],

          spaperName: '',       //考试名称
          npaperCategory: '',   //考试类别1=服务安全与规范测评，2=服务能力测评，3=工艺
          sfieldIds: [],         //领域id
          sproductIds: [],       //产品id
          sbrandId: '',         //品牌id
          nauthentication: '',  //认证情况

          // 第三步
          dpublishTime: [],       //考试时间
          sanswerDuration: '',    //答卷时长 不限时长 -1
          sanswerSecond: '',      //答题次数 无限次 -1
          npassScore: '',         //及格分数
          nexcellentScore: '',    //优秀分数
          spaperExplain: '',      //考试说明

          userId: getStorageUserRoleId(),   //登录用户id
        },
        allOraginForm:{},
        isMandatory: true, //产品品牌是否必填
        rules: {
          // 考试来源
          npaperSource:[
            { required: true, message: '请选择考试来源', trigger: 'change' },
          ],
          // 费用类型
          ncostType: [
            { required: true, message: '请选择费用类型', trigger: 'change' },
          ],
          // 考试名称
          spaperName: [
            { required: true, message: '请输入考试名称', trigger: 'blur' },
            { min: 1, max: 20, message: '长度在 1 到 20 个字符之间', trigger: 'blur' }
          ],
          // 考试类别
          npaperCategory: [
            { required: true, message: '请选择考试类别', trigger: 'change' },
          ],
          // 领域
          sfieldIds: [
            {required: true, message: '请选择考试领域', trigger: 'change'}
          ],
          // 产品
          sproductIds: [
            {required: true, message: '请选择考试产品', trigger: 'change'}
          ],
          // 品牌
          sbrandId: [
            {required: true, message: '请选择考试品牌', trigger: 'change'}
          ],
          //属性类型
          nattributeType:[
            { required: true, message: '请选择属性类型', trigger: 'change' },
          ],
          // 难度
          ndifficultyLevel: [
            { required: true, message: '请选择难度类别', trigger: 'change' },
          ],
          //认证情况
          nauthentication: [
            { required: true, message: '请选择认证情况', trigger: 'change' },
          ]
        },

        singleScore: '',      //单选分数
        multiScore: '',       //多选分数
        judgeScroe: '',       //判断分数

        singleList: [],       //单选列表
        multiList: [],        //多选列表
        judgeList: [],        //判断列表

        activeNames: ['a','b','c'],

        //添加课程弹框里的数据
        productListTwo: [],       //获取弹框产品列表
        drawerForm: {
          pageNum: 1,
          pageSize: 20,
          rational: true,
          spaperNo: '',


          nquestionType: '',        //题型
          nquestionCategory: '',    //试题分类
          squestions: '',           //试题内容
          nquestionLevel: '',       //试题难度
          sfieldId: '',             //领域id
          sproductId: '',           //产品id
          sbrandId: '',             //品牌id
          createrName: '',          //创始人
          pickerTime: [],           //创建时间
        },
        searchData:{},
        oraginForm:{},
        total: 0,

        tableData: [],
        multipleSelection: [],      //选中
        // END


        durationRadio: 1,           //答卷时长
        secondRadio: 1,             //答题次数


        patternType: '',              //a1 选题 b2随机

        // 总分第三步用到
        totalTopicNumThree: 0,        //第三步总题
        totalScoreNumThree: 0,        //第三步总分

        creatorName: '',              //创建人
        creatorTime: '',              //创建时间


        // 随机

        randomSingleData: [],       //随机单选数据
        randomMultiData: [],        //随机多选数据
        randomJudgeData: [],        //随机判断数据
        // END


        // 回显
        setLoading: false,            //考试设置loading
        // END

        //迭代
        editIndex: '',                //编辑的下标
      }
    },
    beforeRouteEnter (to, from, next) {
      next(vm => {
        if (!vm.$route.query.type) {
          vm.$message.warning('缺少创建考试组卷')
          setTimeout(() => {
            vm.removeTabList({
              id: vm.$route.meta.menuId,
            })
            vm.$router.push('/examination/course')
          }, 300)
        } else {
          vm.patternType = vm.$route.query.type
          vm.form.spaperNo = vm.$route.query.spaperNo || ''
          if(vm.$route.query.activeName == 'add' && vm.$route.query.type == 'a') {
            vm.activeName= 'add'
            if(vm.form.spaperNo) {
              vm.setLoading = true
              vm.getExaminationSetEcho();
            }
          }else if(vm.$route.query.activeName == 'addtwo' && vm.$route.query.type == 'b'){
            vm.activeName= 'addtwo'
            if(vm.form.spaperNo) {
              vm.randomSingleData = []       //随机单选数据
              vm.randomMultiData = []        //随机多选数据
              vm.randomJudgeData = []        //随机判断数据
              vm.setLoading = true
              vm.getExaminationSetEcho();
            }
          }else if(vm.$route.query.activeName == 'test') {
            vm.activeName= 'test'
          }else {
            vm.activeName= 'create'
            vm.clearAllFun();
          }
        }
      })
    },
    activated(){

    },
    computed: {
      ...mapState({
        domianList: state => state.area.domianList,
        brandList: state => state.area.brandList,
        courseList: state => state.area.courseList
      }),
      // 选题
      singleCommonNum() {
        return Number(this.singleScore) * this.singleList.length
      },
      multiCommonNum() {
        return Number(this.multiScore) * this.multiList.length
      },
      judgeCommonNum() {
        return Number(this.judgeScroe) * this.judgeList.length
      },
      totalScoreNum() {
        return this.singleCommonNum + this.multiCommonNum + this.judgeCommonNum || 0
      },
      totalTopicNum() {
        return this.singleList.length + this.multiList.length + this.judgeList.length
      },
      // END

      // 随机
      randomTotalTopicNum(){
        let a = 0,b = 0,c = 0;
        if(this.randomSingleData.length) {
          this.randomSingleData.forEach(function(val){
            a += val.num
          })
        }
        if(this.randomMultiData.length) {
          this.randomMultiData.forEach(function(val){
            b += val.num
          })
        }
        if(this.randomJudgeData.length) {
          this.randomJudgeData.forEach(function(val){
            c += val.num
          })
        }
        return a+b+c
      },
      randomTotalScoreNum(){
        let a = 0,b = 0,c = 0;
        if(this.randomSingleData.length) {
          this.randomSingleData.forEach(function(val){
            a += val.typeScore
          })
        }
        if(this.randomMultiData.length) {
          this.randomMultiData.forEach(function(val){
            b += val.typeScore
          })
        }
        if(this.randomJudgeData.length) {
          this.randomJudgeData.forEach(function(val){
            c += val.typeScore
          })
        }
        return a+b+c
      }
    },
    watch: {
      'form.npassScore': {
        handler(val) {
          if(val>=this.totalScoreNumThree) {
            this.form.npassScore = ''
            return this.$message.warning('及格分数不可大于等于总分')
          }
        },
        immediate: false
      },
      'form.nexcellentScore': {
        handler(val) {
          if(val>this.totalScoreNumThree) {
            this.form.nexcellentScore = ''
            return this.$message.warning('优秀分数不可大于总分')
          }
        },
        immediate: false
      },
    },
    
    
    created() {
      // 加载模块
      setTimeout(() => { this.loadModal = true }, 100)
      setTimeout(() => { this.loadModal2 = true }, 100)
      this.oraginForm = JSON.parse(JSON.stringify(this.drawerForm))
      this.allOraginForm = JSON.parse(JSON.stringify(this.form))
    },
    methods: {
      ...mapActions('app', [
        'removeTabList'
      ]),
      
      
      clearProductList(){
        this.serviceList = []
        this.productList = []
        this.form.sproductIds = []
        this.form.sbrandId = ''
        this.form.serviceStageId = ''
      },
       // 获取产品 服务类型（服务内容）
      getProductList(){
        if(this.form.sfieldIds.length >= 2) {
          this.isDisabledProduct = true
          this.isDisabledBrandId = true
          this.isDisabledServiceSelect = true
          this.productList = []
          this.form.sproductIds = []
          this.form.sbrandId = ''
          this.form.serviceStageId = ''
        }else {
          this.isDisabledProduct = false
          this.isDisabledServiceSelect = false
          this.form.sproductIds = []
          this.form.serviceStageId = ''
          getProductSelect({productDomainId:this.form.sfieldIds[0]}).then(res=>{
            res.Result == 1 ? this.productList=res.Data: []
          })
          getServiceSelect({productDomainId:this.form.sfieldIds[0]}).then(res=>{
              res.Result == 1 ? this.serviceList=res.Data: []
          })
        }
      },

      // 弹框里获取产品
      getProductListTwo(){
          getProductSelect({productDomainId:this.drawerForm.sfieldId}).then(res=>{
              res.Result == 1 ? this.productListTwo=res.Data: []
          })
      },
      disabledSbrandId(){
        if(this.form.sproductIds.length >= 2) {
          this.isDisabledBrandId = true;
          this.form.sbrandId = ''
        }else{
          this.isDisabledBrandId = false;
        }
      },
      clearBrandId(){
        this.form.sbrandId = ''
        this.isDisabledBrandId = true
      },
      // 领域 是否必填
      sfieldIsMandatory(){
        this.$nextTick(()=>{
          if(this.form.npaperCategory == 2) {
            this.isMandatory = true
          }else{
            this.isMandatory = false
          }
        })
      },
      // 第一步（点击下一步）
      submitNextStepForm(formName){
        this.$refs[formName].validate((valid) => {
          if (valid) {
            if(this.patternType == 'a'){
              this.$router.push('/examination/createCourse?type='+ this.patternType +'&activeName=add')
              this.activeName = "add"
            }else if(this.patternType == 'b') {
              this.$router.push('/examination/createCourse?type='+ this.patternType +'&activeName=addtwo')
              this.activeName = "addtwo"
            }else {
              this.$message.warning('缺少创建考试组卷')
              setTimeout(() => {
                this.removeTabList({
                  id: this.$route.meta.menuId,
                })
                this.$router.push('/examination/course')
              }, 300)
            }
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      //添加试题
      addQuestionsDrawer(){
        this.drawer = true;
        this.handleSearch();
      },
      // 关闭试题
      handleClose(){
        this.drawer = false;
      },
      handleSearch() {
        this.searchData = Object.assign({}, this.drawerForm)
        this.handleCurrentChange(1)
      },
      handleCurrentChange(val) {
        if (this.listLoading) return
        this.drawerForm.pageNum = val
        this.searchData.pageNum = val
        this.GetQuestionBankList()
      },
      handleSizeChange(val) {
        if (this.listLoading) return
        this.drawerForm.pageNum = 1
        this.drawerForm.pageSize = val
        this.searchData.pageNum = 1
        this.searchData.pageSize = val
        this.GetQuestionBankList()
      },
      async GetQuestionBankList(){
        this.listLoading = true
        let data = JSON.parse(JSON.stringify(this.searchData))
        !data.nquestionType && delete data.nquestionType
        !data.nquestionCategory && delete data.nquestionCategory
        data.nquestionLevel==='' && delete data.nquestionLevel
        !data.sfieldId && delete data.sfieldId
        !data.sproductId && delete data.sproductId
        !data.sbrandId && delete data.sbrandId
        !data.squestions && delete data.squestions
        !data.createrName && delete data.createrName
        !data.spaperNo && delete data.spaperNo
        if (data.pickerTime && data.pickerTime.length) {
            data.daddDateBegin = data.pickerTime[0] + ' 00:00:01'
            data.daddDateEnd = data.pickerTime[1] + ' 23:59:59'
        }
        delete data.pickerTime
        let res = await questionBankList(data)
        this.listLoading = false
        this.tableData = res.Data.datas
        this.tableData = this.tableData.map(obj => {
            obj.isSelected = false
            return obj
        })
        let commonArr = []
        commonArr = commonArr.concat(this.singleList, this.multiList, this.judgeList);
        if(commonArr.length) {
          this.tableData = this.tableData.map(item => {
            commonArr.forEach(_item => {
              if(_item.nquestionNo === item.nquestionNo) {
                item.isSelected = true
              }
            })
            return item
          })
          this.tableData.forEach(item => {
            if(item.isSelected){
              this.$nextTick(()=>{
                this.$refs.multipleTable.toggleRowSelection(item,true);
              })
            }
          });
        }
        this.total = res.Data.total
      },
      handleReset() {
        this.drawerForm = JSON.parse(JSON.stringify(this.oraginForm))
        this.handleSearch()
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      //添加试题确认按钮
      confirmQuestionsSubmit(){
        let selectionList = this.multipleSelection
        let commonArr = []
        commonArr = commonArr.concat(this.singleList, this.multiList, this.judgeList);
        if(commonArr.length){
          selectionList = this.multipleSelection.filter(item => !commonArr.some(ele=>ele.nquestionNo===item.nquestionNo));
        }
        selectionList = selectionList.map(obj=>{
          let arr = []
          for (const key in obj) {
            let ar = key.split('soption')
            if (!ar[0] && ar[1].length == 1 && obj[key]) {
              arr.push({
                label: obj[key]
              })
            }
          }
          obj.sopArr = arr
          obj.isSelected = true;
          return obj
        })
        selectionList.map(obj => {
          switch(obj.nquestionType) {
            case 1:
              this.singleList.push(obj)
              break;
            case 2:
              this.multiList.push(obj)
              break;
            case 3:
              this.judgeList.push(obj)
              break;
          }
        })
        this.drawer = false
        this.$message.success('添加成功')
      },
      //禁止选中的条件
      checkSelectable(row) {
        return row.isSelected == false
      },
      // 删除所有试题
      deleteAllQuestions(index) {
        switch(index) {
          case 1:
            this.singleList = [];
            break;
          case 2:
            this.multiList = [];
            break;
          case 3:
            this.judgeList = [];
            break;
        }
        this.$message.success('删除成功')
      },
      // 删除某一题
      deleteRow(index, rows) {
        rows.splice(index, 1);
        this.$message.success('删除成功')
      },
      // 上移
      upClick(i,rows) {
        let newArr = this.swapItems(rows, i, i - 1)
        rows = newArr
      },
      // 下移
      downClick(i,rows) {
        let newArr = this.swapItems(rows, i, i + 1)
        rows = newArr
      },
      swapItems(rows, i, y) {
        rows[i] = rows.splice(y, 1, rows[i])[0];
        return rows;
      },
      //点击编辑
      handleOpen(rows) {
        let data = {
          nquestionNos:[],
          operateType: 1,
        }
        data.nquestionNos.push(rows.nquestionNo)
        questionBankIsExist(data).then(res=> {
          if(res.Result != 1) {
            this.$confirm(res.Message, '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.$refs.modal.open(rows)
            }).catch(() => {});
          }else{
            this.$refs.modal.open(rows)
          }
        })
      },
      onEditSubmit(val){
        questionBankModel(val).then(res=> {
            if(res.Result != 1) {
              return this.$message.error(res.Message)
            }
            let arr = []
            for (const key in val) {
              let ar = key.split('soption')
              if (!ar[0] && ar[1].length == 1 && val[key]) {
                arr.push({
                  label: val[key]
                })
              }
            }
            val.sopArr = arr
            val.isSelected = true;
            switch(val.nquestionType) {
              case 1:
                this.singleList = this.singleList.map(item => item.nquestionNo === val.nquestionNo ? val : item)
                break;
              case 2:
                this.multiList = this.multiList.map(item => item.nquestionNo === val.nquestionNo ? val : item)
                break;
              case 3:
                this.judgeList = this.judgeList.map(item => item.nquestionNo === val.nquestionNo ? val : item)
                break;
            }
            this.$message.success('修改成功！')
            this.$refs.modal.editorClose()
        })
      },
      // 选题第二步（点击下一步）
      submitNextStep(){
        this.$refs.ruleForm.validate((valid) => {
          if (valid || !valid&&this.form.spaperNo) {
            if(!this.singleList.length && !this.multiList.length && !this.judgeList.length) {
              return this.$message.warning('请添加试题')
            }
            if(this.singleList.length && !this.singleScore || this.multiList.length && !this.multiScore || this.judgeList.length && !this.judgeScroe) {
              return this.$message.warning('请检查大题分数')
            }
            this.$router.push('/examination/createCourse?type='+ this.patternType +'&activeName=test')
            this.activeName = "test"
            this.totalTopicNumThree = this.totalTopicNum
            this.totalScoreNumThree = this.totalScoreNum
          }else {
            this.$router.push('/examination/createCourse?type='+ this.patternType +'&activeName=create')
            this.activeName = "create"
            return false;
          }
        });
      },
      //随机第二步 （单击下一步）
      randomSubmitNextStep(){
        this.$refs.ruleForm.validate((valid) => {
          if (valid || !valid&&this.form.spaperNo) {
            if(!this.randomSingleData.length && !this.randomMultiData.length && !this.randomJudgeData.length) {
              return this.$message.warning('请添加试题')
            }
            this.$router.push('/examination/createCourse?type='+ this.patternType +'&activeName=test')
            this.activeName = "test"
            this.totalTopicNumThree = this.randomTotalTopicNum
            this.totalScoreNumThree = this.randomTotalScoreNum
          }else {
            this.$router.push('/examination/createCourse?type='+ this.patternType +'&activeName=create')
            this.activeName = "create"
            return false;
          }
        });
      },
      // 随机删除试题
      deleteRandom(e, index) {
        switch(e) {
          case 1:
            this.randomSingleData.splice(index,1);
            break;
          case 2:
            this.randomMultiData.splice(index,1);
            break;
          case 3:
            this.randomJudgeData.splice(index,1);
            break;
        }
      },
      // 第三步 （点击编辑返回上一步）
      prevEditor(){
        let name = ''
        if(this.patternType == 'a') {
          name = "add"
        }else {
          name = "addtwo"
        }
        this.$router.push('/examination/createCourse?type='+ this.patternType +'&activeName='+ name)
        this.activeName = name
      },
      // 第三步 （保存/发布）
      submitAllData(type) {
        this.$refs.ruleForm.validate((valid) => {
          if (valid || !valid&&this.form.spaperNo) {
            let singleQuestionNos = []
            let multiQuestionNos = []
            let judgeQuestionNos = []
            let commonArr = []
            let data =  Object.assign({}, this.form)
            if(!data.dpublishTime.length) {
              return this.$message.warning('请选择考试时间')
            }
            if(!data.npassScore) {
              return this.$message.warning('及格分数不能为空')
            }
            if(!data.nexcellentScore) {
              return this.$message.warning('优秀分数不能为空')
            }
            if(data.npassScore>this.totalScoreNumThree) {
              return this.$message.warning('及格分数线不可超过总分,请检查后重新输入')
            }
            if(data.nexcellentScore>this.totalScoreNumThree) {
              return this.$message.warning('优秀分数线不可超过总分,请检查后重新输入')
            }
            if(Number(data.nexcellentScore) <= Number(data.npassScore)) {
              return this.$message.warning('优秀分数必须大于当前及格分数')
            }
            if(this.durationRadio == 2&&!data.sanswerDuration) {
              return this.$message.warning('有限时长不能为空')
            }
            if(this.secondRadio == 2&&!data.sanswerSecond) {
              return this.$message.warning('答题次数不能为空')
            }
            if(data.dpublishTime && data.dpublishTime.length){
              data.dpublishDate = data.dpublishTime[0]
              data.dunpublishDate = data.dpublishTime[1]
            }
            delete data.dpublishTime
            !data.nauthentication && delete data.nauthentication
            !data.npaperAttribute && delete data.npaperAttribute
            !data.npaperCategory && delete data.npaperCategory
            !data.npassScore && delete data.npassScore
            data.npublishStatus = type
            data.ntotalScore = this.totalScoreNumThree
            // norganizedPattern 选题1 随机2
            if(this.patternType == 'a') {
              data.norganizedPattern = 1
              if(this.singleList.length) {
                singleQuestionNos = this.singleList.map(obj => {
                  return {
                    nquestionNo: obj.nquestionNo,
                    nquestionScore: this.singleScore
                  }
                })
              }
              if(this.multiList.length) {
                multiQuestionNos = this.multiList.map(obj => {
                  return {
                    nquestionNo: obj.nquestionNo,
                    nquestionScore: this.multiScore
                  }
                })
              }
              if(this.judgeList.length) {
                judgeQuestionNos = this.judgeList.map(obj => {
                  return {
                    nquestionNo: obj.nquestionNo,
                    nquestionScore: this.judgeScroe
                  }
                })
              }
              commonArr = commonArr.concat(singleQuestionNos, multiQuestionNos, judgeQuestionNos);
              // data.questionNos  [{nquestionNo: '',nquestionScore:''}]
              data.questionNos = commonArr
            }else{
              data.norganizedPattern = 2
              let randomSingleDataArr = []
              let randomMultiDataArr = []
              let randomJudgeDataArr = []
              if(this.randomSingleData.length) {
                randomSingleDataArr = this.randomSingleData.map(obj => {
                  return {
                    nquestionCategory: obj.nquestionCategory,
                    nquestionLevel: obj.nquestionLevel,
                    nquestionNum: obj.num,
                    nquestionType: obj.nquestionType,
                    nscore: obj.score,
                    ntotalScore: obj.typeScore,
                    sfieldId: obj.sfieldId,
                    sproductId: obj.sproductId,
                    sbrandId: obj.sbrandId,
                  }
                })
              }
              if(this.randomMultiData.length) {
                randomMultiDataArr = this.randomMultiData.map(obj => {
                  return {
                    nquestionCategory: obj.nquestionCategory,
                    nquestionLevel: obj.nquestionLevel,
                    nquestionNum: obj.num,
                    nquestionType: obj.nquestionType,
                    nscore: obj.score,
                    ntotalScore: obj.typeScore,
                    sfieldId: obj.sfieldId,
                    sproductId: obj.sproductId,
                    sbrandId: obj.sbrandId,
                  }
                })
              }
              if(this.randomJudgeData.length) {
                randomJudgeDataArr = this.randomJudgeData.map(obj => {
                  return {
                    nquestionCategory: obj.nquestionCategory,
                    nquestionLevel: obj.nquestionLevel,
                    nquestionNum: obj.num,
                    nquestionType: obj.nquestionType,
                    nscore: obj.score,
                    ntotalScore: obj.typeScore,
                    sfieldId: obj.sfieldId,
                    sproductId: obj.sproductId,
                    sbrandId: obj.sbrandId,
                  }
                })
              }
              data.examStypeSetRs = data.examStypeSetRs.concat(randomSingleDataArr, randomMultiDataArr, randomJudgeDataArr);
            }
            !data.examStypeSetRs && delete data.examStypeSetRs
            !data.norganizedPattern && delete data.norganizedPattern
            console.log(data.norganizedPattern)
            if(this.durationRadio == 1) {
              data.sanswerDuration = -1
            }
            !data.sanswerDuration && delete data.sanswerDuration
            if(this.secondRadio == 1) {
              data.sanswerSecond = -1
            }
            !data.npaperSource && delete data.npaperSource  //考试来源
            !data.ncostType && delete data.ncostType        //费用类型
            !data.schannelSku && delete data.schannelSku
            !data.ntestPrice && delete data.ntestPrice
            !data.nchannelPrice && delete data.nchannelPrice
            data.ndifficultyLevel === '' && delete data.ndifficultyLevel
            !data.scurriculumId && delete data.scurriculumId
            !data.nattributeType && delete data.nattributeType
            !data.serviceStageId && delete data.serviceStageId


            !data.sanswerSecond && delete data.sanswerSecond
            !data.sfieldIds.length && delete data.sfieldIds
            !data.sproductIds.length && delete data.sproductIds
            !data.sbrandId && delete data.sbrandId
            !data.spaperExplain && delete data.spaperExplain
            !data.spaperName && delete data.spaperName
            !data.spaperNo && delete data.spaperNo
            !data.userId && delete data.userId
            this.submitAllLoading = true
            examinationSet(data).then(res=> {
              this.submitAllLoading = false
              if(res.Result != 1) {
                return this.$message.error(res.Message?res.Message:'提交失败！')
              }
              if(type != 1) {
                this.$message.success('保存成功！')
              }else{
                this.$message.success('发布成功！')
              }
              setTimeout(() => {
                this.removeTabList({
                  id: this.$route.meta.menuId,
                })
                this.$router.push('/examination/course')
              }, 300)
              this.clearAllFun()
            })
            console.log(data)
          }else {
            this.$router.push('/examination/createCourse?type='+ this.patternType +'&activeName=create')
            this.activeName = "create"
            return false;
          }
        });
        
      },
      clearAllFun(){
        this.form = JSON.parse(JSON.stringify(this.allOraginForm))
        this.drawerForm = JSON.parse(JSON.stringify(this.oraginForm))
        this.$refs.ruleForm.resetFields();
        this.productList = []
        this.serviceList = []
        this.productListTwo = []
        this.singleList = []
        this.multiList = []
        this.judgeList = []
        this.singleScore = ''
        this.multiScore = ''
        this.judgeScroe = ''
        this.durationRadio = 1
        this.secondRadio = 1
        this.randomSingleData = []
        this.randomMultiData = []
        this.randomJudgeData = []
        this.creatorName = ''
        this.creatorTime = ''
        this.isMandatory = false
        this.form.npassScore = ''
        this.form.nexcellentScore = ''
        this.isDisabledProduct = true
        this.isDisabledBrandId = true
        this.isDisabledServiceSelect = true
      },
      async handleOpenTwo(type){
        let data = {
          nquestionType: type
        }
        let tips = ''
        switch(type) {
          case 1:
            tips = '单选题'
            break;
          case 2:
            tips = '多选题'
            break;
          case 3:
            tips = '判断题'
            break;
        }
        let res = await questionBankQueryNum(data)
        if(!res.Data) {
          return this.$message.warning(tips+'暂无，请移步到试卷库添加')
        }
        this.$refs.modalTwo.open(type,2,res)
      },
      //提交随机组卷
      seveRandomNextBtn(data) {
        questionBankRandom(data).then(res=>{
          if(res.Result != 1) {
            return this.$message.error('保存失败，请重新保存')
          }
          res.Data.typs.map(obj => {
            switch(obj.nquestionType){
              case 1:
                if(this.editIndex === '') {
                  this.randomSingleData.push(obj)
                }else{
                  this.$set(this.randomSingleData, this.editIndex, obj)
                  this.editIndex = ''
                }
                break;
              case 2:
                if(this.editIndex === '') {
                  this.randomMultiData.push(obj)
                }else{
                  this.$set(this.randomMultiData, this.editIndex, obj)
                  this.editIndex = ''
                }
                break;
              case 3:
                if(this.editIndex === '') {
                  this.randomJudgeData.push(obj)
                }else{
                  this.$set(this.randomJudgeData, this.editIndex, obj)
                  this.editIndex = ''
                }
                break;
            }
          })
          this.$refs.modalTwo.cancel()
          this.$message.success('保存成功！')
        })
      },
      // 编辑随机组卷
      randomEditData(data,type,index) {
        this.editIndex = index
        this.$refs.modalTwo.editOpen(data,type,2)
      },
      //选题 点击标题（单选/多选/判断）
      onCollapseItem(item) {
        var arr = []
        switch(item){
          case 1:
            item = 'a'
            break;
          case 2:
            item = 'b'
            break;
          case 3:
            item = 'c'
            break
        }
        arr.push(item)
        this.activeNames = arr
      },
      // 回显
      async getExaminationSetEcho(){
        this.singleList = [];
        this.multiList = [];
        this.judgeList = [];
        this.form.dpublishTime = [];
        let data = {
          spaperNo: this.form.spaperNo
        }
        let res = await examinationSetEcho(data)
        this.setLoading = false
        if(res.Result != 1) {
          setTimeout(() => {
            this.removeTabList({
              id: this.$route.meta.menuId,
            })
            this.$router.push('/examination/course')
          }, 300)
          return this.$message.error('获取数据失败请联系开发人员')
        }
        this.$nextTick(()=> {
          // this.$message.warning('提示：任何操作需在下一步试卷设置页保存')
          this.$notify({
            title: '提示：',
            message: '任何操作需在下一步试卷设置页保存',
            type: 'warning'
          });
          this.form.dpublishTime.push(res.Data.dstartEffectiveTime)
          this.form.dpublishTime.push(res.Data.dendEffectiveTime)
          this.totalScoreNumThree = res.Data.ntotalScore    //总分
          this.totalTopicNumThree = res.Data.num            //题数
          this.creatorName = res.Data.createrName           //创建人
          this.creatorTime = res.Data.dcreateDate           //创建时间
          this.form.spaperName = res.Data.spaperName              //试卷名称
          this.form.npaperCategory = res.Data.npaperCategory      //试卷类别
          this.form.sfieldId = res.Data.sfieldIdList || []               //领域
          this.form.sproductId = res.Data.sproductIdList || []           //产品
          this.form.sbrandId = res.Data.sbrandId               //品牌
          this.form.nauthentication = res.Data.nauthentication    //认证情况
          this.form.npassScore = res.Data.npassScore              //及格分数
          this.form.nexcellentScore = res.Data.nexcellentScore    //优秀分数

          this.form.npaperSource = res.Data.npaperSource          //考试来源
          this.form.ncostType = res.Data.ncostType                //费用类型
          this.form.schannelSku = res.Data.schannelSku            //渠道SKU
          this.form.ntestPrice = res.Data.ntestPrice
          this.form.nchannelPrice = res.Data.nchannelPrice        
          this.form.ndifficultyLevel = res.Data.ndifficultyLevel  
          this.form.nattributeType = res.Data.nattributeType
          // TODO:? 为什么要注释掉 ？
          // this.form.scurriculumId = res.Data.scurriculumId        //关联课程id
          // END
          this.form.serviceStageId = res.Data.serviceStageId

          if(res.Data.sanswerDuration == -1) {
            this.durationRadio = 1
          }else {
            this.durationRadio = 2
            this.form.sanswerDuration = res.Data.sanswerDuration
          }
          if(res.Data.sanswerSecond == -1) {
            this.secondRadio = 1
          }else {
            this.secondRadio = 2
            this.form.sanswerSecond = res.Data.sanswerSecond
          }
          this.form.spaperExplain = res.Data.spaperExplain
          // norganizedPattern 1=选题组卷，2=随机组卷
          if(res.Data.norganizedPattern == 1) {
            console.log('选题组卷')
            res.Data.qbListEcho.typs.map(obj => {
              switch(obj.nquestionType) {
                case 1:
                  this.singleScore = obj.eachScore
                  obj.questionBanks.map(item=> {
                    let arr = []
                    for (const key in item) {
                      let ar = key.split('soption')
                      if (!ar[0] && ar[1].length == 1 && item[key]) {
                        arr.push({
                          label: item[key]
                        })
                      }
                    }
                    item.sopArr = arr
                    item.isSelected = true;
                    this.singleList.push(item)
                  })
                  break;
                case 2:
                  this.multiScore = obj.eachScore
                  obj.questionBanks.map(item=> {
                    let arr = []
                    for (const key in item) {
                      let ar = key.split('soption')
                      if (!ar[0] && ar[1].length == 1 && item[key]) {
                        arr.push({
                          label: item[key]
                        })
                      }
                    }
                    item.sopArr = arr
                    item.isSelected = true;
                    this.multiList.push(item)
                  })
                  break;
                case 3:
                  this.judgeScroe = obj.eachScore
                  obj.questionBanks.map(item=> {
                    let arr = []
                    for (const key in item) {
                      let ar = key.split('soption')
                      if (!ar[0] && ar[1].length == 1 && item[key]) {
                        arr.push({
                          label: item[key]
                        })
                      }
                    }
                    item.sopArr = arr
                    item.isSelected = true;
                    this.judgeList.push(item)
                  })
                  break;
              }
            })
          } else {
            res.Data.qbListEcho.typs.map(obj => {
              obj.score = obj.eachScore
              switch(obj.nquestionType){
                case 1:
                  this.randomSingleData.push(obj)
                  break;
                case 2:
                  this.randomMultiData.push(obj)
                  break;
                case 3:
                  this.randomJudgeData.push(obj)
                  break;
              }
            })
          }
        })
      }
      
    }
  }
</script>

<style lang="scss">
  .el-tabs__header {
    margin: 0 0 30px;
  }
  .el-tabs__content {
    overflow: visible;
  }
  .one-ruleForm {
    position: relative;
    .next-button {
      position: absolute;
      right: 0;
      top: -70px;
    }
    > .el-form-item {
      margin-bottom: 30px !important;
    }
  }
  .danger {
    color: #f56c6c;
  }
  .danger:focus,.danger:hover {
    color: #f78989;
  }
  .empty {
    color: #909399;
  }
  .empty:focus,.empty:hover {
    color: #a6a9ad;
  }
  .test-total {
    box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
    .test-itme-total {
      .itme-head {
        height: 48px;
        background: #F9F9F9;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 20px;
        h4 {
          font-size: 17px;
          color: #111111;
          cursor: pointer;
        }
        .add-test-button {
          margin-left: 20px;
        }
      }
      .item-content {
        min-height: 105px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 20px;
        .text {
          font-size: 14px;
          color: #111111;
          span {
            font-weight: bold;
            font-size: 16px;
            padding: 0 6px;
          }
        }
        .el-form-item {
          margin-bottom: 0 !important;
        }
      }
    }
    .test-bottom-total {
      height: 104px;
      margin: 0 30px;
      border-top: 1px solid #E7E7E7;
      display: flex;
      justify-content: space-around;
      align-items: center;
      color: #333333;
      >div {
        font-size: 16px;
        span {
          font-size: 18px;
          padding-right: 6px;
          font-weight: bold;
        }
      }
    }
  }
  .test-title {
    text-align: center;
    font-size: 20px;
    color: #333333;
    line-height: 50px;
    // margin-top: -26px;
  }
  .test-content {
    // border: 1px solid #E7E7E7;
    box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
    padding: 20px;
    min-height: 100px;
    h4 {
      font-size: 17px;
      color: #111111;
    }
    .test-list {
      padding: 0 22px;
      text-align: left;
      >div {
        margin-bottom: 20px;
      }
      .test-min-title {
        font-size: 14px;
        font-weight: bold;
        color: #333333;
        line-height: 30px;
        margin-bottom: 10px;
      }
      .test-list-content {
        padding: 0 10px;
        .correct {
          color: #67c23a !important;
        }
      }
      .test-select {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        flex-wrap: wrap;
        
        .test-select-itme {
          width: 46%;
          margin-bottom: 10px;
          padding-right: 20px;
          font-size: 14px;
          color: #333333;
        }
      }
      .test-answer-oper {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
      .test-is {
        .test-select-itme {
          width: 100%;
        }
      }
    }
    .footer {
      height: 100px;
      padding: 30px 0;
      display: flex;
      align-items: center;
      justify-content: space-around;
      font-size: 16px;
      font-weight: 500;
      color: #333333;
      span {
        font-size: 24px;
        font-weight: 600;
      }
    }
  }
  .el-drawer__body {
    padding: 20px;
  }
  .demo-drawer__content {
    display: flex;
    flex-direction: column;
    height: 100%;
  }
  .el-drawer.rtl{
      overflow-y: auto;
  }
  .el-drawer__header {
    margin-bottom: -30px;
  }
  .form-test-set {
    padding: 20px 0;
    .el-form-item {
      padding: 10px 0;
    }
  }
  // 随机组卷
  .test-two-add {
    .test-two-item-head {
      padding: 0 24px;      
      background: #F9F9F9;
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 48px;
      margin-bottom: 20px;
      h4 {
        font-size: 17px;
        color: #111111;
      }
      .two-head-totel {
        color: #333333;
        font-size: 14px;
        span {
          font-size: 18px;
          font-weight: 600;
        }
      }
    }
    .test-two-content {
      .test-two-items {
        border: 1px solid #E5E5E5;
        min-height: 120px;
        position: relative;
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        .two-items-list {
          display: flex;
          flex-wrap: wrap;
          text-align: left;
          width: 100%;
          padding: 16px 0;
          > div {
            width: 40%;
            padding-left: 28px;
            height: 34px;
            line-height: 34px;
            font-size: 14px;
            color: #333333;
            font-weight: 500;
          }
        }
        .two-items-button {
          position: absolute;
          right: 20px;
          bottom: 6px;
        }
      }
    }
    .test-add-button {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 30px;
    }
  }
  .el-drawer__header {
    position: relative;
    z-index: 2;
  }
</style>